const textFieldModalCloneEquipModel = {
  name: 'Nome Novo Tipo do Equipamento',
  description: 'Descrição do Equipamento'
};

export default textFieldModalCloneEquipModel;
